import style from './style.module.scss'
import { Header, Text } from '@crossfit/design-system'
import { useSettings } from 'components/Settings'
import TabContainer from 'components/Admin/Shared/Menu/Shared/TabContainer'
import { TabConfig } from 'components/Admin/Shared/Menu/types'
import { useStripePaymentPortal } from 'pages/Programming/hooks'
import { useAffiliate } from 'hooks/useAffiliate'

export const directoryPageId = 'directory-page' as const
export const directoryPagePath = 'directory-page'

export const contactInfoId = 'contact-info' as const
export const contactInfoPath = 'contact-info'

export const billingInvoicesId = 'billing-and-invoices' as const
export const billingInvoicesPath = 'billing-and-invoices'

export const coachesAndStaffId = 'coaches-and-staff' as const
export const coachesAndStaffPath = 'coaches-and-staff'

export const helpId = 'help' as const
export const helpPath = 'help'

export const contactUsId = 'contact-us' as const
export const contactUsPath = 'contact-us'

export type CurrentTabType = TabConfig['id']

export default function DesktopTabs() {
  const {
    canAccessAdminDirectoryPage,
    canAccessAdminContactInfoPage,
    canAccessAdminBillingAndInvoices,
    canAccessAdminCoachesAndStaffPage,
    canAccessAdminHelpPage,
    canAccessAdminContactUsPage,
  } = useAffiliate()
  const settings = useSettings((s) => s.data)
  const { centralAccountText } = settings

  return (
    <>
      <Header as='h2' size='xs' className={style.header}>
        {centralAccountText}
      </Header>
      <nav className={style.tabs}>
        <div className={style.tabGroup}>
          {canAccessAdminDirectoryPage && <TabContainer id={directoryPageId} />}
          {canAccessAdminContactInfoPage && <TabContainer id={contactInfoId} />}
          {canAccessAdminBillingAndInvoices && (
            <TabContainer id={billingInvoicesId} isExternalLink={true} />
          )}
          {canAccessAdminCoachesAndStaffPage && (
            <TabContainer id={coachesAndStaffId} />
          )}
        </div>
        <div className={style.tabGroup}>
          <Text
            as='label'
            type='overline'
            size='sm'
            className={style.tabGroupLabel}
          >
            {'Resources'}
          </Text>
          {canAccessAdminHelpPage && (
            <TabContainer id={helpId} isExternalLink={true} />
          )}
          {canAccessAdminContactUsPage && (
            <TabContainer id={contactUsId} isExternalLink={true} />
          )}
        </div>
      </nav>
    </>
  )
}
